<template>
    <div class="ly-cascader-check">
        <Row v-for="(el, i) in bindValue" :key="i">
            <Col span="8">
                <ly-cascader :value="bindValue[i]" :init-data="shareData" :attrs="cascaderAttrs" @input="handleChange(i, arguments)" :ref="'cascader_' + i"></ly-cascader>
            </Col> 
            <Col span="4">
                <Button  type="warning" @click="handleRemove(i)" icon="md-close" :disabled="bindValue.length <= 1">移除</Button>
            </Col>
        </Row>
        <Row>
            <Col span="12">
                <Button type="dashed" long  @click="handleAdd" icon="md-add">添加一项</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
    /**
     * 级联多选组件选择
     * 此组件满足需求： 可以选择多个分类，但数据只请求一次
     * value的值为数组［ ‘一级value’， ‘二级value’］
     */
    export default {
        name: 'LyCascaderCheck',
        props: {
            value: {
                type: [Object, Array, String],
                default: _ => []
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                local_key: '', // 本地存储的key，使用api的地址当key
                isInitBind: false, // 标识是否初始化绑定过了
                bindValue: [[]], // 多个分类的选择，所以是二维数组
                shareData: [], // 多个级联中的贡献数据
                cascaderAttrs: {} // 级联的配置
            }
        },
        watch: {
            value: {
                handler () {
                    this.setBindValue()
                },
                immediate: true
            }
        },
        created () {
            let loacalsave = true
            if(this.attrs.hasOwnProperty('isloacalsave')){
                loacalsave = this.attrs.isloacalsave
            }else{
                loacalsave = true
            }
            // 设置级联的配置
            this.cascaderAttrs = {
                api: this.attrs.api,
                isLoacalSave: loacalsave
            }
        },
        methods: {
            /**
             * 设置绑定的值
             */
            setBindValue () {
                if (!this.value || this.isInitBind) return
                if (this.value && this.value.length > 0) {
                    this.bindValue =  JSON.parse(JSON.stringify(this.value))
                    this.isInitBind = true
                }
            },
            /**
             * 选择的监听
             * @param index 索引，
             * @param arg 传递过来的参数
             */
            handleChange (index, arg) {
                this.$set(this.bindValue, index, arg[0])
                setTimeout (el => {
                    this.emitBindValue()
                }, 100)
            },
            /**
             * 添加一项
             */
            handleAdd () {
                // 新加一个前，要去获取第一个的共享数据
                if (this.shareData.length < 1) {
                    this.shareData = this.$refs['cascader_0'][0]['bindData']
                }
                this.bindValue.push([])
            },
            /**
             * 删除一项
             */
            handleRemove (i) {
                this.bindValue.splice(i, 1)
                this.emitBindValue()
            },
            /**
             * 设置绑定的值
             */
            emitBindValue () {
                let arr = []
                this.bindValue.forEach(el => {
                    if (el.length > 0) {
                        arr.push(el)
                    }
                })
                this.$emit('input', JSON.parse(JSON.stringify(arr)))
            }
        }
    }
</script>
<style>
    .ly-cascader-check .ivu-row {
        margin-bottom: 8px;
    }
    .ly-cascader-check .ivu-col-span-4{
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// ../projectCore/src/components/cascader-check/src/index.vue